import './styles/Download.css';
import React, { Component } from "react";
import firebase from './.././firebaseconfig';
class DownLoad extends Component {
    constructor(props){
        super(props);
        this.state = {
            loading: true
        }
    }
    componentDidMount(){
        var almacen = firebase.storage();
        var almacenRef = almacen.ref();
        var clientRef = almacenRef.child('client.apk');
        var serverRef = almacenRef.child('server.apk');
        clientRef.getDownloadURL().then(function(url) {
          document.getElementById("clientLink").href = url;
        }).catch(function(error) {});
        serverRef.getDownloadURL().then(function(url) {
          document.getElementById("serverLink").href = url;
        }).catch(function(error) {});
        this.setState({loading: false});
    }
    render(){
        return( this.state.loading ? <div id="cont"></div> :
            <div id="flexXinergy" className="text-center">
                <div className="row">
                    <div className="col-2"></div>
                    <div className="col-8">
                        <h5 className="text-dark">Ja son disponibles per probar les primeres versions de Xinergy!
                <br/><br/><a href="/" className="h5 p-1">Torna enrere...</a></h5>
                    </div>
                    <div className="col-2"></div>
                </div>
                <div className="pb-3">
                    <div className="download-item p-4 mx-5">
                        <img src="./logoxy.png" alt=""/>
                        <a className="h5 p-1" id="serverLink" href="#flexXinergy"><i className="fa fa-download"></i>{"   "}Xinergy Server</a>
                    </div>
                    <div className="download-item p-4 mx-5">
                        <img src="./logoxy.png" alt=""/>
                        <a className="h5 p-1" id="clientLink" href="#flexXinergy"><i className="fa fa-download"></i>{"   "}Xinergy Client</a>
                    </div>
                </div>
            </div>
        );
    }
}
export default DownLoad;